import { ErrorInfoSVG } from "@/Component/Common/SVGs/CommonSVG"
import { CapitalizedFirstLetter } from "../Other/CapitalizedFirstLetter"

export const getErrorValue = (fieldName, errors, touched) => {
    return errors[fieldName] && touched[fieldName] ? true : false
}

const ErrorMessages = (props) => {
    const { fieldName, errors, touched, field = 'input' } = props
    return (
        <>
            {
                errors[fieldName] && touched[fieldName] &&
                <div className="flex items-center mt-2">
                    <ErrorInfoSVG customClass={'mr-1'} /><span className="text-red-500 text-xs">
                        {/* {errors[fieldName]} */}
                        {CapitalizedFirstLetter(errors[fieldName], field)}
                    </span>
                </div>
            }
        </>
    )
}

export default ErrorMessages
